import {connect} from '@modifi/redux'
import {aCloseDialog} from '@modifi/plugin-dialogs'

import SplitTransactionDialog from './SplitTransactionDialog'
import {
  selectSplitPending,
  selectSplitErrorMessage,
  aSplitTransaction,
  aCleanupSplit,
} from '../../../../modules/split-transaction'
import {aFetchTransactions, selectRelevantFlag} from '../../store'

const mapStateToProps = state => ({
  isSplitting: selectSplitPending(state),
  splitError: selectSplitErrorMessage(state),
  isRelevant: selectRelevantFlag(state),
})

const mapDispatchToProps = {
  splitTransaction: aSplitTransaction,
  fetchTransactions: aFetchTransactions,
  cleanupSplit: aCleanupSplit,
  handleClose: aCloseDialog,
}

export const DIALOG_NAME = 'dialog-split-transaction'

export default connect(mapStateToProps, mapDispatchToProps)(SplitTransactionDialog)
